module.exports = __webpack_public_path__ + "img/v2.2.ea9fec14.png";